<!--充电机数据 -->
<template>
  <div id="dataIndex">
    <!-- 列表 -->
    <div style="position: relative;">
      <!-- 删选 -->
      <div class="searchWarp">
        <!-- 公司选择 -->
        <SearchCompany v-model="selectCompany2" :value="selectCompany2" @change="changeSearch" />
        <el-input v-model="searchObj.sn" :placeholder="$t('AllDevices.SearchDeviceNameOrSn')" class="input-with-select deviceNameTable" clearable @clear="changeSearch">
          <el-button slot="append" icon="el-icon-search" @click="changeSearch" />
        </el-input>
      </div>
      <el-table id="dataIndexTable" v-loading="loading" :data="tableData" style="width: 100%" border>
        <el-table-column prop="deviceName" :label="$t('dashboard.DeviceName')" align="center" />
        <el-table-column prop="deviceSn" :label="$t('BondOrUpdateDevice.SN')" align="center" />
        <el-table-column prop="companyName" :label="$t('adminView.CompanyInfo')" align="center" />
        <!-- <el-table-column prop="batteryVoltage" :label="$t('basicinfo.SystemVoltage')+'(V)'" align="center" />
        <el-table-column prop="batteryCapacityZh" :label="$t('BondOrUpdateDevice.Capacity')+'(Ah)'" align="center" />
        <el-table-column prop="soc" :label="$t('warningPage.SOC')+'(%)'" align="center" />
        <el-table-column prop="updateTimeZh" :label="$t('dashboard.LatestUpdate')" align="center" /> -->
        <el-table-column prop="" :label="$t('yhubReport.Operating')" align="center">
          <template slot-scope="scope">
            <div style="text-align: center;">
              <el-button type="primary" icon="el-icon-view" size="mini" @click="gotoDetailPage(scope.row)" />
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 列表模块————分页 -->
      <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
        <div class="pagination-container">
          <el-pagination
            v-if="pageshow"
            background
            current-page.sync="listQuery.pageInfo.page"
            :page-sizes="listQuery.pageInfo.pageList"
            :page-size="listQuery.pageInfo.limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="listQuery.pageInfo.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { findBluetoothDeviceList } from '@/api/blueTooth'
import { pagination } from '@/utils/init_table'

export default {
  data() {
    return {
      // 分页----start
      listQuery: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow: true,
      // 分页----end,
      loading: true,
      searchObj: {},
      tableData: [],
      selectCompany: [],
      selectCompany2: []
    }
  },
  created() {
    this.queryList()
  },
  methods: {
    queryList() {
      var param = {
        'key': this.searchObj.sn,
        'companyIdList': this.selectCompany,
        pageNum: this.listQuery.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery.pageInfo.pageSize // 分页--每一页的列表的行数 10 20 50
      }
      this.loading = true
      findBluetoothDeviceList(param).then(res => { // 基本信息
        this.loading = false
        if (res.resultCode === 1001 && res.resultModel) {
          this.listQuery.pageInfo.total = res.resultModel.total // 分页
          // console.log(res.resultModel)
          this.tableData = res.resultModel.list
          this.tableData.forEach(v => {
            if (v.batteryCapacity)v.batteryCapacityZh = Math.round(v.batteryCapacity / 100)
          })
        }
      })
    },
    gotoDetailPage(row) { // 去详情页
      var routeData = this.$router.resolve({
        path: '/blueTooth/yhubDataDetail',
        query: {
          mcuId: row.mcuId
        }
      })
      window.open(routeData.href, '_self')
    },
    // 筛选改变事件
    changeSearch() {
      if (this.searchObj.sn) {
        // 去掉首尾空格
        this.searchObj.sn = this.searchObj.sn.replace(/(^\s*)|(\s*$)/g, '').replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '').replace(/(^\s*)|(\s*$)/g, '')
      }
      this.selectCompany = []
      this.selectCompany2.forEach(v => {
        this.selectCompany.push((typeof v === 'string' && v.indexOf('ID') > -1) ? v.slice(2) : v)
      })
      this.listQuery.pageInfo.pageNum = 1
      this.pageshow = false
      this.queryList()
      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    // 分页----start
    handleSizeChange(val, e) {
      // 每一页的列表的行数 10 20 50
      this.listQuery.pageInfo.pageSize = val
      this.queryList()
    },
    handleCurrentChange(val, e) {
      // 选中某一页
      this.listQuery.pageInfo.pageNum = val
      this.queryList()
    }
    // 分页----end

  }
}
</script>
<style lang="scss">
#dataIndex{
  background: #fff;
  padding: 13px 20px;
  .searchWarp{
    margin-bottom: 10px;
  }
  .searchWarp .el-input-group {
    width: 40%!important;
    max-width: 400px!important;
    margin-top: 13px;
  }
  #dataIndexTable .el-button{
    margin:5px 0 ;
  }
}
</style>
